<script>
export default {
    name: "GatePassReport",

    data() {

        return {
            patients: [],
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                search: ``,
                ward: ``,
            }
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchPatients(), ]).then(() => {}).catch(() => {});
    },

    methods: {

        fetchPatients() {
            if(!this.filter.dateFrom || !this.filter.dateTo) return Promise.reject();

            let url = `Admissions/GetGatePassPatientsforDateWard?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
            url += `&Ward=${this.filter.ward}`;
            this.$root.loading = true;
            return this.$http.get(url)
                .then(response => {
                    this.patients = response.data;
                    this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchSearchedPatientGatePass() {
            if(!this.filter.search) return this.fetchPatients();

            this.$root.loading = true;
            return this.$http.get(`Admissions/GetAdmittedPatientsforSearch?SearchText=${this.filter.search}`)
                .then(response => {
                    this.patients = response.data.patientAdmissions;
                    this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        printGatePassReport() {

            window.open(`/reports/patients/gate-pass-report/print?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printGatePass(patient) {
            window.open(`/admissions/gate-pass/${patient.patientID}/${patient.dateAdmitted}`, 
                '_blank', 
                `GatePassPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>Gate Pass Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Gate Pass Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" id="grid-search" 
                    v-model.trim="filter.search" 
                    @keydown.enter="fetchSearchedPatientGatePass" 
                    placeholder="Press enter to search" 
                    class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="$root.checkAuth('AccessOldData')
                ">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom"
                    id="grid-date-from" class="input-control input-sm text-xs" >
              </div> 
              <div class="md:w-1/6 sm:w-full p-tiny" v-if="!$root.checkAuth('AccessOldData')">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" :min="$root.minFilterDate"
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" 
                    id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="fetchPatients">
                        <i class="fa fa-filter"></i> Filter</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="$root.exportToExcel(`gate-pass-report`, `gatePassReport`)">
                        <i class="fa fa-file-excel"></i> Export</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button 
                    class="btn-sm btn-info text-xs rounded"
                    @click.prevent="printGatePassReport">
                        <i class="fa fa-print"></i> Print</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="gatePassReport">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/6">Patient</th>
                            <th class="p-tiny flex-1">IPFile No</th>
                            <th class="p-tiny flex-1">Ward Type</th>
                            <th class="p-tiny flex-1">Admitted</th>
                            <th class="p-tiny flex-1">Discharged</th>
                            <th class="p-tiny flex-1">Ward</th>
                            <th class="p-tiny flex-1">Bed</th>
                            <th class="p-tiny flex-1">Days</th>
                            <th class="p-tiny flex-1">Approved By</th>
                            <th class="p-tiny w-1/4">PMode</th>
                            <th class="p-tiny flex-1">Gate Pass</th>
                        </tr>
                  </thead>
                  <tfoot>
                      <tr class="w-full flex">
                          <td class="w-1/2 p-tiny"></td>
                          <td class="w-1/2 p-tiny text-right">Total Patients: {{ patients.length }}</td>
                      </tr>
                  </tfoot>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:65vh;">
                      <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                          <td class="p-tiny w-1/6">{{ patient.names }}</td>
                          <td class="p-tiny flex-1">{{ patient.ipfileno }}</td>
                          <td class="p-tiny flex-1">{{ patient.type }}</td>
                          <td class="p-tiny flex-1">{{ patient.dateAdmitted | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ patient.discharged ? `Yes` : `No` }}</td>
                          <td class="p-tiny flex-1">{{ patient.ward }}</td>
                          <td class="p-tiny flex-1">{{ patient.bed }}</td>
                          <td class="p-tiny flex-1">{{ patient.days }}</td>
                          <td class="p-tiny flex-1">{{ patient.approvedBy }}</td>
                          <td class="p-tiny w-1/4">{{ patient.pmode }}</td>
                          <td class="p-tiny flex-1">
                            <button 
                                @click.prevent="printGatePass(patient)"
                                class="btn-sm btn-info text-xs rounded ml-2">
                                    <i class="fa fa-print"></i> Gate pass</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>